module.exports = __webpack_public_path__ + "img/ic_close.47125460.svg";